export default __webpack_public_path__ + "static/media/Web_02-01.fb5aec80.png";